import { useEffect, useState } from "react";
import Select from 'react-select';
import { ddStylesSmall } from "../utils/CommonStyles.js";

let delegateOptions = [];

function UserDelegateTableRow({ index, delegates, handleSubmit, setError, t, setAdd, oddIdx }) {
	const [delegateLoaded, setDelegateLoaded] = useState(false);
	const [delegateSelected, setDelegateSelected] = useState({ name: "delegateKeys", label: "", value: "0-0-0" });
	const [isSubmit, setIsSubmit] = useState(false);

	useEffect(() => {
		setDelegates(delegates);
	}, []);

	function setDelegates(delegates) {
		let delegateValue = {};
		delegateOptions = [];
		if (delegates && delegates.length > 0) {
			delegates.map((delegate, idx) => {

				delegateValue.label = delegate.parentCompanyName;
				delegateValue.value = delegate.delegateKey + "-" + delegate.companyId + "-" + delegate.level;
				delegateOptions.push(delegateValue);
				if (idx == 0) {
					setDelegateSelected({ ...delegateSelected, label: (delegateValue.label), value: delegateValue.value });
				}
				delegateValue = {};
			});
			setDelegateLoaded(true);
		}
	}
	const delegateHandler = (selectedOption, action) => {
		let delegateValues = selectedOption ? selectedOption.value : 0;
		let delegateLabel = selectedOption ? selectedOption.label : "";
		setDelegateSelected({ ...delegateSelected, label: (delegateLabel), value: delegateValues });
	}

	function submitComplete() {
		setIsSubmit(false);
		setDelegateSelected({name: "delegateKey", label: "", value: "0-0-0"});
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let delegateValues = delegateSelected.value;
		let delegateValueArr = [];
		let initialValues = {};
		if(delegateValues){
			delegateValueArr = delegateValues.split("-");
		}
		if(delegateValueArr.length >= 3){
			initialValues = {
				delegateKey: delegateValueArr[0],
				delegateCompanyId: delegateValueArr[1],
				level:delegateValueArr[2],
			};
		} else {
			initialValues = {
				delegateKey: 0,
				delegateCompanyId: 0,
				level:0
			};
		}

		if (initialValues.delegateKey === 0) {
			setError(t("error.delegateKeyReqd"));
			setIsSubmit(false);
		} else if(initialValues.delegateCompanyId === 0){
			setError(t("error.delegateKeyReqd"));
			setIsSubmit(false);
		} else {
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
		setDelegateSelected({name: "delegateKey", label: "", value: "0-0-0"});
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{delegateLoaded ? <Select
					name="delegateKey"
					options={delegateOptions}
					onChange={delegateHandler}
					placeholder={""}
					value={delegateSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="delegateKey-input"
					styles={ddStylesSmall}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{(delegateOptions && delegateOptions.length > 0 ) ?
					(<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>)
					:
					(<></>)
				}
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button>
			</td>
		</tr>
	)

}
export default UserDelegateTableRow;